import { render, staticRenderFns } from "./UdemyCoupons.vue?vue&type=template&id=ca95b460&scoped=true"
import script from "./UdemyCoupons.vue?vue&type=script&lang=js"
export * from "./UdemyCoupons.vue?vue&type=script&lang=js"
import style0 from "./UdemyCoupons.vue?vue&type=style&index=0&id=ca95b460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca95b460",
  null
  
)

export default component.exports